import {
  Topic as Data,
  TopicCollection as Collection,
} from '@/typings/api/Topic'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class TopicsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/topics';
}
